module.exports = __webpack_public_path__ + "img/receipt.2f0bf37f.svg";